// Constants
import { DOCUMENT_ELEMENT } from '@/scripts/constants';

// Others
import {
  AnimatedListLine, customSelect,
  Dropdown,
  Form, HeaderNav,
  initGoogleMaps,
  PageFilters,
  RollHoverBtn,
  swiperSliderAdvanced, TabFilters, Tabs,
  DynamicHoverLink,
  // HoverDistortion,
  SeeMore,
} from '@/components';

import { AnimatedSection, selectors } from '@/scripts/animation';

import {
  counterScene,
  headerScene, parallaxImage,
  scrollToTopScene,
  simpleRevealer,
  stripesRevealer,
} from '@/components/_scrollmagic';

import { createEvent, leadZero, resizeCover } from '@/scripts/utils';

import plugins from './plugins';

const initBasics = (container, usePJAX) => new Promise((resolve) => {
  const basics = [];
  // responsive table
  $(container).find('.editable table').responsiveTable();

  // init animated list line
  container.querySelectorAll('[data-role*="animated-list-line"]')
    .forEach((list) => {
      basics.push(new AnimatedListLine(list));
    });

  // Dynamic Hover
  container.querySelectorAll('[data-role*="dynamic-hover-link"]')
    .forEach((el) => {
      basics.push(new DynamicHoverLink({
        el,
        scaleInterval: { from: 0, to: 1 },
        letterSpacing: false,
      }));
    });

  // init tab-filters
  container.querySelectorAll('[data-role*="grid-with-filters"]')
    .forEach((el) => {
      basics.push(new TabFilters({
        el,
        transitionDuration: 700,
        lineController: el.querySelector('[data-role*="animated-list-line"]'),
      }));
    });

  // tabs init
  container.querySelectorAll('[data-role*="tab-list-container"]')
    .forEach((el) => {
      basics.push(new Tabs({
        mainContainer: el,
        lineController: el.querySelector('[data-role*="animated-list-line"]'),
      }));
    });

  // cover tab in HP
  // container.querySelectorAll('[data-role*="distortion-image"]')
  //   .forEach((element) => {
  //     basics.push(new HoverDistortion({ // eslint-disable-line no-unused-vars
  //       element,
  //       intensity: 0.2,
  //       container: '[data-role*="distortion-container"]',
  //       btnSelector: '[data-role*="distortion-btn"]',
  //     }));
  //   });

  // init dropdowns
  container.querySelectorAll('[data-role*="dropdown-container"]')
    .forEach((element) => {
      basics.push(new Dropdown({
        element,
      }));
    });

  // init page-filters form
  basics.push(new PageFilters({
    allowPopstate: !usePJAX,
    element: container.querySelector('[data-role*="page-filters-container"]'),
  }));

  // Lead zero 1 -> 01, 11 -> 11
  $(container).find('[data-lead-zero="true"] span').text((i, text) => leadZero(text.trim()));

  // Add current year
  $(container).find('.current-year').text((new Date()).getFullYear());

  // split-text
  $(container).find('[data-split-text="true"]').each(function trim() {
    const text = $(this).text();
    $(this).text($.trim(text)).lettering('words').children('span')
      .lettering();
  });

  $(container).find('[data-split-text="button-letters"]').find('span').each(function trim() {
    const text = $(this).text();
    $(this).text($.trim(text)).lettering();
  });

  // roll-hover buttons
  container.querySelectorAll('[data-role*="roll-hover-btn"]')
    .forEach((button) => {
      basics.push(new RollHoverBtn(button));
    });

  // google maps
  container.querySelectorAll('[data-role*="google-maps-container"]')
    .forEach((map) => {
      basics.push(initGoogleMaps(map));
    });

  // selects
  container.querySelectorAll('[data-role*="custom-select"]')
    .forEach((el) => {
      basics.push(customSelect(el));
    });

  // contact-form
  container.querySelectorAll('[data-role*="contact-form"]')
    .forEach((form) => {
      basics.push(new Form(form));
    });

  // subscribe-form
  container.querySelectorAll('[data-role*="subscribe-form"]')
    .forEach((form) => {
      basics.push(new Form(form));
    });

  container.querySelectorAll('[data-role="see-more"]')
    .forEach((btn) => {
      basics.push(new SeeMore({
        button: btn,
        elements: '.property__item',
      }));
    });

  // Main Menu
  basics.push(new HeaderNav({ // eslint-disable-line no-new
    container,
    menuScrollElement: '[data-role="menu"]',
    transitionDuration: 450, // $_menu-duration in scss file.
  }));

  // resize cover section
  basics.push(resizeCover(container));

  resolve(basics);
});

const initSliders = container => new Promise((resolve) => {
  const sliders = [];
  sliders.push(swiperSliderAdvanced({
    container,
    selector: 'media-slider',
    slidesPerView: 2,
    breakpoints: {
      639: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
    restOptions: {
      observer: true,
      observeParents: true,
    },
  }));

  sliders.push(swiperSliderAdvanced({
    container,
    selector: 'media-slider-with-fraction',
    pagination: true,
    paginationType: 'custom',
    slidesPerView: 1,
    dynamicBullets: false,
    // spaceBetween: 0,
  }));

  // DEMO

  sliders.push(swiperSliderAdvanced({
    container,
    selector: 'two-halves',
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: true,
    pagination: true,
    paginationType: 'bullets',
    restOptions: {
      effect: 'fade',
    },
  }));

  sliders.push(swiperSliderAdvanced({
    container,
    selector: 'another-items',
    slidesPerView: 2,
    breakpoints: {
      639: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  }));

  sliders.push(swiperSliderAdvanced({
    container,
    selector: 'two-halves-texts',
    cropContainer: true,
    slidesPerView: 1,
    connect: 'two-halves-images',
  }));

  resolve(sliders);
});

const initScrollMagic = container => new Promise((resolve) => {
  const scenes = [];
  // build scrollMagic
  Array
    .from(container.querySelectorAll(selectors.section))
    .map(section => new AnimatedSection(section))
    .forEach((scene) => {
      scenes.push(scene);
      scene.init();
    });

  scenes.push(scrollToTopScene(container));
  scenes.push(...stripesRevealer(container));
  scenes.push(...simpleRevealer(container));
  scenes.push(...parallaxImage(container));
  scenes.push(headerScene(container));
  scenes.push(...counterScene(container));

  resolve(scenes);
});

export default function initPlugins(container, usePJAX = false) {
  return new Promise(async (resolve) => {
    const inited = [
      ...await initBasics(container, usePJAX),
      ...await initSliders(container, usePJAX),
      ...await initScrollMagic(container, usePJAX),
    ];

    if (inited) {
      plugins.push(...inited);
      DOCUMENT_ELEMENT.dispatchEvent(createEvent('lazy:update'));
      if ('jQuery' in window) {
        window.jQuery(window).trigger('pageTransition');
      }
      resolve(true);
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/plugins/initPlugins.js